import { RecordState } from '@coin/shared/core/util-enums';
import { HttpParams } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

const DEFAULT_TABLE_FILTER = `&Query.State=${RecordState.Active}&Query.State=${RecordState.Outdated}`;
const IRRELEVANT_TABLE_FILTER = `&Query.State=${RecordState.Irrelevant}`;

export class RecordHelper {
  public static getDefaultTableFilter(showIrrelevantRecords: boolean): string {
    return showIrrelevantRecords ? IRRELEVANT_TABLE_FILTER : DEFAULT_TABLE_FILTER;
  }

  public static getMassQueryFilter(filterChanged$: BehaviorSubject<string>, showIrrelevantRecords: boolean): string {
    return (filterChanged$?.value?.substring(1) ?? '') + this.getDefaultTableFilter(showIrrelevantRecords);
  }

  /**
   * Builds a query filter that scopes a batch operation to the explicitly selected records only.
   * Used when "Select All" is not active, so the batch endpoint operates on the chosen rows
   * instead of the whole filtered set.
   */
  public static getSelectedIdsQueryFilter(recordIds: string[], showIrrelevantRecords: boolean): string {
    const idFilter = (recordIds ?? []).filter(Boolean).map(id => `Query.Id=${id}`).join('&');
    return idFilter + this.getDefaultTableFilter(showIrrelevantRecords);
  }

  public static encapsulateQuery(query: string): string {
    if (!query) return query;

    let encapsulated = new HttpParams({ fromString: query });
    encapsulated = encapsulated.delete('');
    encapsulated
      .keys()
      .filter(key => !key.startsWith('Query.'))
      .forEach(key => {
        const values = encapsulated.getAll(key);
        values.forEach(value => {
          encapsulated = encapsulated.append(`Query.${key}`, value);
        });
        encapsulated = encapsulated.delete(key);
      });
    return encapsulated.toString();
  }
}
